import { DISCOUNT_TYPE } from "@swiggy-private/cart-types";
import styled from "styled-components";

export const ExpressContainer = styled.div<{ discountType: DISCOUNT_TYPE }>(({ discountType }) => ({
    position: "relative",
    top: discountType === DISCOUNT_TYPE.CASHBACK ? "-16px" : "-18px",
    left: "46px",
}));

export const LottieWrapper = styled.div<{ discountType: DISCOUNT_TYPE }>(({ discountType }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: discountType === DISCOUNT_TYPE.CASHBACK ? "200px" : "220px",
    height: "20px",
    zIndex: 300,
    display: "block",
}));
